import { MenuKeys } from "../../menus/menu-keys";
import { ControllerContext } from "../controller";
import { ControllerContextKey } from "./contextKeys";

function getBuffer(command: number): ArrayBuffer {
  const arrayBuffer = new ArrayBuffer(12);
  const view = new DataView(arrayBuffer);
  view.setInt32(0, command, true);
  view.setBigInt64(4, 0n, true);
  return view.buffer;
}

/** Needs manually kept in sync with server's `messageTypes.ts` */
export const playerCommandTypes: Record<
  | "pressUp"
  | "releaseUp"
  | "pressDown"
  | "releaseDown"
  | "pressLeft"
  | "releaseLeft"
  | "pressRight"
  | "releaseRight"
  | "pressA"
  | "releaseA"
  | "pressB"
  | "releaseB",
  number
> = {
  pressUp: 0,
  releaseUp: 1,
  pressDown: 2,
  releaseDown: 3,
  pressLeft: 4,
  releaseLeft: 5,
  pressRight: 6,
  releaseRight: 7,
  pressA: 8,
  releaseA: 9,
  pressB: 10,
  releaseB: 11,
};

export const networkGameplayContext: ControllerContext = {
  start: {
    onDown: (_e, ctx) => {
      ctx.menuManager.pushMenu(MenuKeys.OnlineGameplayMenu);
      ctx.controller.pushContext(ControllerContextKey.OnlineGameplayMenu);
    },
  },
  select: {
    onDown: (_e, _ctx) => {},
    onUp: (_e, _ctx) => {},
  },
  actionA: {
    onDown: (_e, ctx) => {
      ctx.wsConnection?.send(getBuffer(playerCommandTypes.pressA));
    },
    onUp: (_e, ctx) => {
      ctx.wsConnection?.send(getBuffer(playerCommandTypes.releaseA));
    },
  },
  actionB: {
    onDown: (_e, ctx) => {
      ctx.wsConnection?.send(getBuffer(playerCommandTypes.pressB));
    },
    onUp: (_e, ctx) => {
      ctx.wsConnection?.send(getBuffer(playerCommandTypes.releaseB));
    },
  },
  up: {
    onDown: (_e, ctx) => {
      ctx.wsConnection?.send(getBuffer(playerCommandTypes.pressUp));
    },
    onUp: (_e, ctx) => {
      ctx.wsConnection?.send(getBuffer(playerCommandTypes.releaseUp));
    },
  },
  down: {
    onDown: (_e, ctx) => {
      ctx.wsConnection?.send(getBuffer(playerCommandTypes.pressDown));
    },
    onUp: (_e, ctx) => {
      ctx.wsConnection?.send(getBuffer(playerCommandTypes.releaseDown));
    },
  },
  left: {
    onDown: (_e, ctx) => {
      ctx.wsConnection?.send(getBuffer(playerCommandTypes.pressLeft));
    },
    onUp: (_e, ctx) => {
      ctx.wsConnection?.send(getBuffer(playerCommandTypes.releaseLeft));
    },
  },
  right: {
    onDown: (_e, ctx) => {
      ctx.wsConnection?.send(getBuffer(playerCommandTypes.pressRight));
    },
    onUp: (_e, ctx) => {
      ctx.wsConnection?.send(getBuffer(playerCommandTypes.releaseRight));
    },
  },
};
